/**
 * Styled voice call icon components.
 *
 * Lucide phone icons render both the handset and the directional arrow/X as
 * separate SVG elements (paths vs. lines/polylines). These wrappers apply
 * `fill-current` + `stroke-none` only to <path> elements so the phone body
 * is filled while arrows and indicators remain outlined.
 *
 * Used in:
 *   - voice-message.tsx (message bubbles)
 *   - last-message-preview.tsx (thread list sidebar)
 */
import { Phone, PhoneIncoming, PhoneMissed, PhoneOutgoing, Voicemail } from "lucide-react";
import { cn } from "@/lib/utils";

type IconProps = { className?: string };

const filledPhone = "[&>path]:fill-current [&>path]:stroke-none";

/** Plain handset, filled — for call/hang-up action buttons. */
export function PhoneFilledIcon({ className }: IconProps) {
  return <Phone className={cn(filledPhone, className)} />;
}

export function PhoneOutgoingIcon({ className }: IconProps) {
  return <PhoneOutgoing className={cn(filledPhone, className)} />;
}

export function PhoneIncomingIcon({ className }: IconProps) {
  return <PhoneIncoming className={cn(filledPhone, className)} />;
}

export function PhoneMissedIcon({ className }: IconProps) {
  return <PhoneMissed className={cn(filledPhone, className)} />;
}

export function VoicemailIcon({ className }: IconProps) {
  return <Voicemail className={className} />;
}
